// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3NOiF","label":"SetPasswdForm_label__1WuWF"};